/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';

/**
 * Service imports.
 */
import { GetService } from '../../../dataservices/get.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { PostingService } from '../posting.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 *  Interface import.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
 * Constant import.
 */
import { EVENT_NAME } from './../../../analytics-event/analytics.constant';
import { SCREEN_NAME, ASSOCIATION_VIEW_ALL_LIMIT, NUMBERS, REPOST_STATUS, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON } from '../../../constants/app.constants';

/**
 * Service imports.
 */
import { AnalyticsEventService } from './../../../analytics-event/analytics-event.service';

/**
 * SDK imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Post Association Component
 */
@Component({
  selector: 'app-post-association',
  templateUrl: './post-association.component.html',
  styleUrls: ['./post-association.component.scss']
})
export class PostAssociationComponent implements OnInit, OnDestroy {

  @Output() nextPostScreen = new EventEmitter();
  @Input() callingFrom: string;
  public user_association_list = [];
  public err_msg = '';
  public showColor = false;
  public is_data_posted = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public config: any;
  public loading_data_in_process = false;
  public timer = 0;
  public showSeperator = false;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Analytics object for publish object.
   */
  public analyticsDataPublish: AnalyticsInterface;
  /**
   * Analytics event on entry object.
   */
  public analyticsDataEntryEvent: AnalyticsInterface;
  /**
   * Analytics visit event object
   */
  private analyticsVisitData: AnalyticsInterface;
  /**
   * Flag to Check if Need to show View More 2 (Association) button
  */
  public view_more_association_flag = false;
  /**
    * Show By Default Associations
  */
  public showAssociationCount = ASSOCIATION_VIEW_ALL_LIMIT;
  /**
    * Show More Association Count
  */
  public showMoreAssociationCount = 0;
  /**
   * Number constant.
   */
  public numbers = NUMBERS;
  /**
   * Necessary instances
   */
  constructor(
    private getSer: GetService,
    private postSer: PostApiService,
    public fcs: FunCollectionService,
    public dss: DataStorageService,
    public multiLangService: MultiLangService,
    public jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private postingService: PostingService,
    private analyticSdk: Analytics
  ) {
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {

    if (this.dss.user_association_list.length == 0 || (this.dss.isRepostStatus === REPOST_STATUS.ONE || this.dss.isRepostStatus === REPOST_STATUS.TWO)) {
      this.dss.user_association_list = [];
      this.getUserAssociation();
    }
    if (this.dss.posting_data.screen3.selected_association.length
      || this.dss.posting_data.screen3.selected_community.length) {

      this.showColor = true;
    } else {
      this.showColor = false;
    }
    if (this.dss.user_association_list.length > ASSOCIATION_VIEW_ALL_LIMIT) {
      this.view_more_association_flag = true;
      this.showMoreAssociationCount = this.dss.user_association_list.length - ASSOCIATION_VIEW_ALL_LIMIT;
    }
    /**
     * Analytics publish data object.
     */
    this.analyticsDataPublish = {
      'event_name': EVENT_NAME.POST_PUBLISH_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.POST_ASSOCIATION
    };
    /**
     * Session start time.
     */
    this.sessiontime.start_time = new Date().getTime().toString();
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', 
      source: this.callingFrom,
      current_screen_name: SCREEN_NAME.POST_ASSOCIATION,
      start_time: parseInt(this.sessiontime.start_time)
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.postingService.postingScreen = SCREEN_NAME.POST_ASSOCIATION;

    /**
     * Show Association which is are selected during post,should be come up on top
     */
    if (this.dss.posting_data.feed_edit_mode.feed_id) {
      this.dss.user_association_list.map((commData, index) => {
        const checkExistingAssociation = (this.dss.posting_data.screen3.selected_association.includes(commData?.association_id.toString())
          || this.dss.posting_data.screen3.selected_association.includes(commData?.association_id));
        if (checkExistingAssociation) {
          this.dss.user_association_list.splice(index, NUMBERS.ONE);
          this.dss.user_association_list.unshift(commData);
        }
      });
    }

  }

  /**
   * upload File For Edit Feed Post
   */
  uploadFileForEditFeedPost(): void {
    this.postingService.uploadFileForEditFeedPost();
  }

  /**
   * upload File
   */
  uploadFile(): void {
    if (this.dss.posting_data.feed_edit_mode.is_edit == 1) {
      this.uploadFileForEditFeedPost(); return;
    }
    this.postingService.uploadFile();
  }

  /**
   * get User Association
   */
  getUserAssociation(): void {
    this.loading_data_in_process = false;

    let repostParam = {
      product_id: NUMBERS.ZERO,
      product_type: NUMBERS.ZERO
    };
    if (this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      repostParam = {
        product_id: this.dss.repostProductId,
        product_type: this.dss.repostProductType
      };
    }
    this.subscriptions.add(this.getSer.getUserAssociation(repostParam).subscribe(resData => {
      this.loading_data_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          if (data.code == 2000) {
            this.dss.user_association_list = data.data.user_association_list;
            if (this.dss.user_association_list.length > ASSOCIATION_VIEW_ALL_LIMIT) {
              this.view_more_association_flag = true;
              this.showMoreAssociationCount = this.dss.user_association_list.length - ASSOCIATION_VIEW_ALL_LIMIT;
            }
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        this.loading_data_in_process = false;
      });
    }));
  }

  /**
   * add Association
   */
  addAssociation(e): void {
    this.err_msg = '';
    if (e.target.checked == true) {
      for (let i = 0; i < this.dss.posting_data.screen3.selected_association.length; i++) {
      }
      if (this.dss.posting_data.screen3.selected_association.indexOf(parseInt(e.target.value, 10)) < 0) {
        this.dss.posting_data.screen3.selected_association.push(e.target.value);
      }
    } else {
      for (let i = 0; i < this.dss.posting_data.screen3.selected_association.length; i++) {
        if (parseInt(this.dss.posting_data.screen3.selected_association[i], 10) === parseInt(e.target.value, 10)) {
          this.dss.posting_data.screen3.selected_association.splice(i, 1);
        }
      }
    }

    if (this.dss.posting_data.screen3.selected_association.length
      || this.dss.posting_data.screen3.selected_community.length) {
      this.showColor = true;
    } else {
      this.showColor = false;
    }
  }

  /**
   * isSelected Ass
   */
  isSelectedAss(ass_id): boolean {
    if (this.dss.calling_from_community) {
      if ((this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id))) {
        return false;
      }
    } else if (this.dss.user_association_list.length == 1 && (this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id))) {
      return true;
    }

    const x = this.dss.posting_data.screen3.selected_association.includes(ass_id);
    if (x == false) {
      return this.dss.posting_data.screen3.selected_association.includes(ass_id.toString());

    } else {
      return true;
    }
  }

  /**
   * feed Post
   */
  feedPost(): void {
    this.postingService.feedPost();
  }

  /**
   * feed Edit Post
   */
  feedEditPost(): void {
    this.postingService.feedEditPost();
  }

  /**
   * file Uploading Process
   */
  fileUploadingProcess(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_ASSOCIATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CREATE_FEED_POST, null);
    this.postSer.setPostButtonStatus(true);
    this.nextPostScreen.emit(6.1);
    this.uploadFile();
  }

  /**
   * Hit analytics vist event on destroy.
   */
  ngOnDestroy(): void {

    this.sessiontime.end_time = new Date().getTime().toString();
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', 
      current_screen_name: SCREEN_NAME.POST_ASSOCIATION,
      start_time: parseInt(this.sessiontime.start_time),
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
  }

  /**
    * To Show Button for More Association
  */
  showMoreAssociation(): void {
    this.showAssociationCount = this.dss.user_association_list.length;
    this.view_more_association_flag = false;
    this.showMoreAssociationCount = 0;
  }

  /**
    * Check if Selected Community List more then 1
    *
  */
  checkSelectedCommunityList(event): void {
    this.showColor = event.showColor;
    this.err_msg = event.errMsg;
  }
}

